import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { LayoutCrudRoutes, PageClientSideFilters } from "@ryde/layout";
import { RydeUiUnit } from "@ryde/shared";

const entity: RydeUiUnit = "dataUpload";

/**
 * The ETL schedules an admin has opened up for customer execution. Columns, filters and the read-only
 * side panel come from the `dataUpload` schemas, so this page is only the shell, like produce-buttons.
 */
export const DataUploadsPage: FC = () => {
  return (
    <PageContextWrapper entity={entity}>
      <PageClientSideFilters />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
